import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Box } from '@mui/material';

import { SvgToTopFill } from '../SvgIcons';


// ----------------------------------------------------------------------

export default function BackToTop({ ...others }) {
  const { pathname } = useLocation();

  const handleBackTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    <Box onClick={handleBackTop} display={'flex'} justifyContent={'center'} sx={{ cursor: 'pointer' }} { ...others }>
        <SvgToTopFill />
    </Box>
  );
}